import React from "react";
import html2canvas from 'html2canvas';

const ExportButton = () => {
  const saveAs = (uri, filename) => {
    var link = document.createElement('a');
    if (typeof link.download === 'string') {
      link.href = uri;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  }
  const handleClick = () => {
    const options = { allowTaint: true, useCORS: true }
    const selector = document.querySelector('.image-preview');
    
    html2canvas(selector, options).then(canvas => {
      saveAs(canvas.toDataURL(), 'zoomback-says-thanks.png');
    });
  }
  return (
    <div>
      <button onClick={handleClick}>
        Export Design
        <i className="far fa-arrow-alt-circle-down"></i>
      </button>
    </div>
  )
};

export default ExportButton;
